import React from 'react';
import {Card} from "react-bootstrap";
import SquareWhatsAppButton from "./SquareWhatsAppButton";
import SquarePhoneButton from "./SquarePhoneButton";
import kevin from "../../../assets/images/kevin.png"
import logo from "../../../assets/images/logo-sm.svg"
function ScheduleAppointment(props) {
    return (

                <Card className="form-control h-100">
                    <Card.Body className="px-0">
                        <div className="d-flex gap-1 align-items-center">

                            <h6 className="mb-0 me-2 text-start">
                                <div>Your advisor is <strong>Kevin</strong></div>
                                <div className=""><small className="mb-0 lh-1 text-black-50">Give him a call or send him a message</small></div>
                            </h6>
                            <div className="d-inline-flex gap-1 gap-sm-3 ms-auto">
                                <SquareWhatsAppButton/>
                                <SquarePhoneButton/>
                            </div>

                        </div>
                        <Card className="bg-lightblue mt-3">
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-start">
                                    <div className="rounded-pill bg-white p-2">
                                        <img className="contact-circle border-0" src={kevin} alt="Kevin"/>
                                    </div>
                                    <div className="d-flex flex-column ms-3">
                                        <h5 className="mb-1">Kevin Coakley</h5>
                                        <h6 className="font-alt text-primary-dark bold mb-3">Financial Advisor</h6>
                                        <a href="mailto:kevin@sussd.ie"  className="font-alt">kevin@sussd.ie</a>
                                        <a href="tel:+35316854888"  className="font-alt">01 685-4888</a>
                                        <img src={logo} alt="Suss'd Logo" className="m-2 ms-auto align-self-end w-100"/>
                                    </div>

                                </div>

                            </Card.Body>
                        </Card>
                    </Card.Body>
                </Card>

    );
}

export default ScheduleAppointment;